// @ts-strict
import { AfterViewInit, Component, HostBinding, Input } from '@angular/core';
import { LMThemeService } from '@banner/lm-theme.service';

@Component({
  selector: 'lm-widget-title',
  template: `
    <ng-container *ngIf="icon">
      <ng-container *ngIf="useSohoIcon; else Img">
        <svg soho-icon icon="{{icon}}" class="widget-title-icon"/>
      </ng-container>
    </ng-container><span lm-custom-tooltip [tooltipContent]="title">{{ title }}</span><ng-template #Img><img ngSrc="{{iconUrl}}" class="widget-title-icon" width="30" height="30"></ng-template>`,
  styles: [`.widget-title-icon { margin-right: 12px; width: 30px; height: 30px; }`]
  })
export class LMWidgetTitleComponent implements AfterViewInit {
  @Input() title = '';
  @Input() icon = '';
  @Input() iconUrl = '';

  @HostBinding('style.display') display = 'inline-flex';
  @HostBinding('style.max-width') maxWidth = '100%';

  public useSohoIcon = false;
  constructor(
      private lmThemeService: LMThemeService
  ) {  }

  ngAfterViewInit() {
    const lplToSohoIcon = this.lmThemeService.lplIconToSohoXI(this.icon as LMIcon);
    this.useSohoIcon = lplToSohoIcon !== null && this.lmThemeService.isValidSohoIcon(this.icon);
  }
}
